import React from "react";
import { Box, Typography, Paper, Chip, Link as MuiLink, Divider, IconButton, Grid } from "@mui/material";

const EscalationInfo = ({ onGoBack }) => {
  const handleGoBack = () => {
    // Call the callback function to reset escalation state
    if (onGoBack) {
      onGoBack();
    }
  };

  return (
    <Box
      sx={{
        color: "#1e293b",
        lineHeight: 1.6,
        py: { xs: 0.5, sm: 1 },
        px: { xs: 1, sm: 2 },
        width: "100vw",
        maxWidth: "none",
        margin: 0,
        position: "relative",
        left: "50%",
        right: "50%",
        marginLeft: "-50vw",
        marginRight: "-50vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          width: "85vw",
          maxWidth: "1600px",
          display: "flex",
          flexDirection: "column",
          gap: { xs: 2, sm: 3 },
        }}
      >
        {/* Go Back Button */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <IconButton onClick={handleGoBack} sx={{ p: 0, mr: 1 }}>
            <img src="/Icons/Goback.svg" alt="Go back" />
          </IconButton>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "20px",
              lineHeight: "24px",
              color: "#253858",
            }}
          >
            Escalation Information
          </Typography>
        </Box>

        {/* Header */}
        <Box sx={{ textAlign: "center", mb: 1 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: "1.875rem",
              fontWeight: 700,
              color: "#1e293b",
              mb: 0.5,
            }}
          >
            Grievance Redressal
          </Typography>
          <Typography
            sx={{
              color: "#64748b",
              fontSize: "1rem",
            }}
          >
            Escalation Information
          </Typography>
        </Box>

        {/* Grievance Escalation Card */}
        <Paper
          elevation={1}
          sx={{
            background: "white",
            border: "1px solid #e2e8f0",
            borderRadius: 3,
            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
            width: "100%",
            maxWidth: "none",
            margin: "0 auto",
            flex: 1,
          }}
        >
          {/* Card Header */}
          <Box
            sx={{
              p: { xs: 1, sm: 1.5 },
              pb: { xs: 0.5, sm: 1 },
              borderBottom: "1px solid #f1f5f9",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontSize: "1.25rem",
                fontWeight: 600,
                color: "#1e293b",
                mb: 1,
              }}
            >
              <svg
                width="20"
                height="20"
                fill="none"
                stroke="#3b82f6"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12,6 12,12 16,14"></polyline>
              </svg>
              <Typography
                sx={{
                  fontSize: "1.25rem",
                  fontWeight: 600,
                  color: "#1e293b",
                }}
              >
                Grievance Redressal Matrix
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "#64748b",
                fontSize: "0.875rem",
              }}
            >
              Your query is currently being handled as per our Grievance Redressal Matrix:
            </Typography>
          </Box>

          {/* Card Content - Two Column Layout */}
          <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
            <Grid container spacing={2} alignItems="center">
              {/* Column 1: Escalation Levels */}
              <Grid item xs={12} md={6}>
                <Box sx={{ mb: { xs: 2, md: 0 } }}>
                  {/* Escalation Levels */}
                  <Box sx={{ mb: 2 }}>
                    {/* Level 1 */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Chip
                        label="Level 1"
                        sx={{
                          backgroundColor: "#3b82f6",
                          color: "white",
                          fontSize: "0.75rem",
                          fontWeight: 500,
                          borderRadius: 1.5,
                          px: 1.5,
                          height: "24px",
                        }}
                      />
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 0.5,
                            flexWrap: "wrap",
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: { xs: "flex-start", sm: "center" },
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 500,
                              color: "#1e293b",
                              fontSize: "1rem",
                            }}
                          >
                            Customer Support
                          </Typography>
                          <Typography
                            sx={{
                              color: "#64748b",
                              fontSize: "0.875rem",
                              display: { xs: "none", sm: "block" },
                            }}
                          >
                            –
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.875rem",
                              fontWeight: 500,
                              color: "#3b82f6",
                            }}
                          >
                            within 10 business days
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Level 2 */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                        mb: 2,
                      }}
                    >
                      <Chip
                        label="Level 2"
                        sx={{
                          backgroundColor: "#f1f5f9",
                          color: "#475569",
                          fontSize: "0.75rem",
                          fontWeight: 500,
                          borderRadius: 1.5,
                          px: 1.5,
                          height: "24px",
                        }}
                      />
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 0.5,
                            flexWrap: "wrap",
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: { xs: "flex-start", sm: "center" },
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 500,
                              color: "#1e293b",
                              fontSize: "1rem",
                            }}
                          >
                            Assistant Nodal Officer
                          </Typography>
                          <Typography
                            sx={{
                              color: "#64748b",
                              fontSize: "0.875rem",
                              display: { xs: "none", sm: "block" },
                            }}
                          >
                            –
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.875rem",
                              fontWeight: 500,
                              color: "#3b82f6",
                            }}
                          >
                            within 20 business days
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Level 3 */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                      }}
                    >
                      <Chip
                        label="Level 3"
                        sx={{
                          backgroundColor: "#f1f5f9",
                          color: "#475569",
                          fontSize: "0.75rem",
                          fontWeight: 500,
                          borderRadius: 1.5,
                          px: 1.5,
                          height: "24px",
                        }}
                      />
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 0.5,
                            flexWrap: "wrap",
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: { xs: "flex-start", sm: "center" },
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 500,
                              color: "#1e293b",
                              fontSize: "1rem",
                            }}
                          >
                            Nodal Officer
                          </Typography>
                          <Typography
                            sx={{
                              color: "#64748b",
                              fontSize: "0.875rem",
                              display: { xs: "none", sm: "block" },
                            }}
                          >
                            –
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.875rem",
                              fontWeight: 500,
                              color: "#3b82f6",
                            }}
                          >
                            within 30 business days
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* Column 2: Escalation Process */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundColor: "#f8fafc",
                    borderRadius: 2,
                    p: { xs: 1.5, sm: 2 },
                    height: "fit-content",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 500,
                      color: "#1e293b",
                      mb: 1,
                      fontSize: "1rem",
                    }}
                  >
                    Escalation Process
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      color: "#64748b",
                      lineHeight: 1.5,
                      mb: 1,
                    }}
                  >
                    If the respective Turnaround Time (TAT) has passed and your issue remains unresolved, 
                    you may escalate by writing to the appropriate level:
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    {/* Level 2 Contact */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontSize: "0.875rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        stroke="#64748b"
                        viewBox="0 0 24 24"
                      >
                        <path d="m4 4 16 0c1.1 0 2 .9 2 2l0 12c0 1.1-.9 2-2 2l-16 0c-1.1 0-2-.9-2-2l0-12c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          color: "#1e293b",
                          fontSize: "0.875rem",
                        }}
                      >
                        Level 2:
                      </Typography>
                      <MuiLink
                        href="mailto:assistantnodalofficer@pbpay.com"
                        sx={{
                          color: "#3b82f6",
                          textDecoration: "none",
                          fontSize: "0.875rem",
                          wordBreak: "break-all",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        assistantnodalofficer@pbpay.com
                      </MuiLink>
                    </Box>

                    {/* Level 3 Contact */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontSize: "0.875rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        stroke="#64748b"
                        viewBox="0 0 24 24"
                      >
                        <path d="m4 4 16 0c1.1 0 2 .9 2 2l0 12c0 1.1-.9 2-2 2l-16 0c-1.1 0-2-.9-2-2l0-12c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          color: "#1e293b",
                          fontSize: "0.875rem",
                        }}
                      >
                        Level 3:
                      </Typography>
                      <MuiLink
                        href="mailto:nodalofficer@pbpay.com"
                        sx={{
                          color: "#3b82f6",
                          textDecoration: "none",
                          fontSize: "0.875rem",
                          wordBreak: "break-all",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        nodalofficer@pbpay.com
                      </MuiLink>
                    </Box>
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      color: "#64748b",
                      fontStyle: "italic",
                    }}
                  >
                    Please include your Ticket ID and grievance details in the email.
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            {/* Thank you message */}
            <Box sx={{ textAlign: "center", pt: 2 }}>
              <Typography
                sx={{
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  color: "#1e293b",
                }}
              >
                Thank you for your patience.
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default EscalationInfo; 